import AGButton from "../../../components/Button";
import AGModalComfirmModal from "../../../components/ComfirmModal";

export interface ApproveConfirmModalProps {
	visible: boolean;
	toggleModal: () => void;
	approveService: () => void;
	zIndex?: number;
	tab?: string;
}
const ApproveConfirmModal = ({
	visible,
	toggleModal,
	approveService,
	zIndex,
	tab
}: ApproveConfirmModalProps) => {

	return (
		<AGModalComfirmModal
			toggleModal={() => {
				toggleModal();
			}}
			title={tab === "service" ? "Approve Service" : "Approve Product" }
			footer={<> <AGButton
				type="Primary"
				onClick={() => {
					approveService();
				}}>
				Approve
			</AGButton>
				<AGButton
					type="Secondary"
					onClick={() => {
						toggleModal();
					}}
				>
					Cancel
				</AGButton></>}
			visible={visible}
			setHeight={190}
			zIndex={zIndex}
		>
			<div style={{ padding: 20 }}>
			Are you sure you want to approve this {tab === "service" ? "service" : "product"}?
			</div>
		</AGModalComfirmModal>

	);
};

export default ApproveConfirmModal;
